'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["indicatorSize", "size", "role", "ariaValueText"];
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { LoadingIndicatorCircle } from "./LoadingIndicatorCircle.mjs";
import { LoadingIndicatorSvg } from "./LoadingIndicatorSvg.mjs";
var indicatorSizes = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};
function LoadingIndicatorComponent(_ref) {
  var indicatorSize = _ref.indicatorSize,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'progressbar' : _ref$role,
    _ref$ariaValueText = _ref.ariaValueText,
    ariaValueText = _ref$ariaValueText === void 0 ? 'Loading' : _ref$ariaValueText,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(LoadingIndicatorSvg, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1 100",
    xmlSpace: "preserve",
    $indicatorSize: indicatorSize || size,
    role: role,
    "aria-valuetext": ariaValueText
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.LoadingIndicator
  }), /*#__PURE__*/React.createElement(LoadingIndicatorCircle, {
    stroke: "none",
    cx: "-140",
    cy: "50",
    r: "32"
  }), /*#__PURE__*/React.createElement(LoadingIndicatorCircle, {
    stroke: "none",
    cx: "0",
    cy: "50",
    r: "32"
  }), /*#__PURE__*/React.createElement(LoadingIndicatorCircle, {
    stroke: "none",
    cx: "140",
    cy: "50",
    r: "32"
  }));
}

/**
 * @deprecated
 * This component is deprecated and will be archived in a future release.
 * It has been renamed {@link https://encore-web.spotify.net/?path=/docs/components-progressdots--default ProgressDots}.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-loadingindicator--docs) |
 * [Encore site](https://encore.spotify.net/web/components/progress-indicators) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/LoadingIndicator) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-12341&t=X3Pv9ZLvoMIaXVBJ-1)
 */
export var LoadingIndicator = Object.assign(LoadingIndicatorComponent, indicatorSizes);